import * as moment from 'moment';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { environment } from '../environments/environment';
import { Creditor } from './creditor';
import { FormData } from './form-data';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {
  /**
   * The API Key that will be used to post the data to the remote service.
   * @type {string}
   */
  private apiKey: string;

  public successMessage: string = undefined;

  public errorMessage: string;

  /**
   * has the form been sent already
   * @type {bool}
   */
  public sending = false;

  /**
   * The base formData which will be passed between sub-components.
   */
  public formData: FormData;

  constructor(private http: HttpClient, private route: ActivatedRoute) {
    this.clearFormData();
  }

  /**
   * Initialise any requirements on initialising this view. This includes getting the
   * required API key from the query parameters.
   */
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params["key"]) {
        this.apiKey = params["key"];
      }
    });
  }

  private fullFormIsValid(): boolean {
    return this.creditorsEntered() && this.validPhoneNumbers();
  }

  public creditorsEntered(): boolean {
    return this.formData.creditors.length > 1;
  }

  public validPhoneNumbers(): boolean {
    return (
      this.validPhoneNumber(this.formData.homeNumber, "landline") &&
      this.validPhoneNumber(this.formData.mobileNumber, "mobile")
    );
  }

  public validPostcode(): boolean {
    return new RegExp(/[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}/i).test(
      this.formData.postalCode
    );
  }

  public validApiKey(): boolean {
    return this.apiKey !== undefined;
  }

  public validPhoneNumber(number: string, type: string): boolean {
    if (number.length <= 0) {
      return true;
    }

    if (type === "mobile") {
      return (
        number === undefined ||
        number === null ||
        number.length === 0 ||
        /^07\d{9}$/.test(number)
      );
    } else if (type === "landline") {
      return (
        number === undefined ||
        number === null ||
        number.length === 0 ||
        /^0[12]\d{8,9}$/.test(number)
      );
    } else {
      return true;
    }
  }

  /**
   * The updateNumberOfCreditors function ensures that at all times the number of creditors
   * number field and the actual number of creditors that have been added match.
   * @param {number} j
   */
  public updateNumberOfCreditors(j: number): void {
    while (j > this.formData.creditors.length) {
      this.formData.creditors.push({
        name: "",
        reference: "",
        balance: 0
      } as Creditor);
    }

    if (this.formData.creditors.length > this.formData.numberOfCreditors) {
      this.formData.numberOfCreditors = this.formData.creditors.length;
    }
  }

  /**
   * The submitFormData function sends the required information to the remote service
   * after converting it to the appropriate format.
   * @param e
   */
  public submitFormData(e): void {
    this.successMessage = undefined;
    this.errorMessage = undefined;
    e.preventDefault();

    if (this.fullFormIsValid()) {
      this.sending = true;
      const dob = moment(this.formData.dateOfBirth, "YYYY-MM-DD", true);
      this.http
        .post(environment.postUrl, {
          apikey: this.apiKey,
          lead: {
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            dateOfBirth: dob.isValid() ? dob.format("YYYY-MM-DD") : null,
            employmentStatus: this.formData.employmentStatus,
            maritalStatus: this.formData.maritalStatus,
            residentialStatus: this.formData.residentialStatus,
            nationalInsuranceNumber: this.formData.nationalInsuranceNumber,
            address: {
              address1: this.formData.address1,
              address2: this.formData.address2,
              address3: this.formData.address3,
              town: this.formData.town,
              postalCode: this.formData.postalCode
            },
            contactDetails: {
              landline: this.formData.homeNumber,
              mobile: this.formData.mobileNumber,
              email: this.formData.email
            }
          },
          creditors: this.formData.creditors.map(item => {
            return {
              name: item.name,
              reference: item.reference,
              value: item.balance * 100
            };
          }),
          meta: {
            adviser: this.formData.adviser,
            reference: this.formData.reference,
            numberOfCreditors: this.formData.numberOfCreditors,
            disposableIncome: this.formData.di
          },
          product: "83eb366f9474f202556fff43",
          autoRefer: true
        })
        .subscribe(
          data => {
            this.sending = false;
            this.clearFormData();
            this.successMessage = "Success";
          },
          err => {
            this.sending = false;
            this.errorMessage =
              err.error.message || "looks like something when wrong!";
            console.error("thrown error:", err);
          }
        );
    }
  }

  private clearFormData(): void {
    this.formData = {
      adviser: "",
      numberOfCreditors: 0,
      reference: "",
      di: 0,
      title: "",
      firstName: "",
      lastName: "",
      homeNumber: "",
      mobileNumber: "",
      email: "",
      address1: "",
      address2: "",
      address3: "",
      town: "",
      postalCode: "",
      dateOfBirth: "",
      employmentStatus: "",
      residentialStatus: "",
      nationalInsuranceNumber: "",
      maritalStatus: "",
      creditors: []
    } as FormData;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/app.component.ts